import { render } from "./DefaultRouter.vue?vue&type=template&id=2d8e968e"
const script = {}
script.render = render

export default script